import './HeadBanner.css'

function HeadBanner(){
    return (
        <>
        <section className="head-banner-section">
            <p className='head-banner-p'>Chegou a hora de </p>
            <h1 className='head-banner-h1'>Acelerar a sua <span className='head-banner-h1-highlight'>carreira</span></h1>
            <h1 className='head-banner-h1'>em <span className='head-banner-h1-highlight'>tecnologia</span></h1>
        </section>
        </>
    )
}

export default HeadBanner;